import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './common/main/main.component';
import { MasterRoutes, ModuleRoutes } from './core/constants/route.constant';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: MasterRoutes.Home,
        loadChildren: () =>
          import('./modules/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: MasterRoutes.Schedule,
        loadChildren: () =>
          import('./modules/schedule/schedule.module').then(
            (m) => m.ScheduleModule
          ),
      },
      {
        path: MasterRoutes.Inventory,
        loadChildren: () =>
          import('./modules/inventory/inventory.module').then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: MasterRoutes.Waste,
        loadChildren: () =>
          import('./modules/waste/waste.module').then(
            (m) => m.WasteModule
          ),
      },
      {
        path: MasterRoutes.HealthPhysics,
        loadChildren: () =>
          import('./modules/health-physics/health-physics.module').then(
            (m) => m.HealthPhysicsModule
          ),
      },
      {
        path: MasterRoutes.Reports,
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: MasterRoutes.Alerts,
        loadChildren: () =>
          import('./modules/alerts/alerts.module').then(
            (m) => m.AlertsModule
          ),
      },
      {
        path: MasterRoutes.Settings,
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: MasterRoutes.ManufacturerPortal,
        loadChildren: () =>
          import('./modules/manufacturer-portal/manufacturer-portal.module').then(
            (m) => m.ManufacturerPortalModule
          ),
      },
      {
        path: MasterRoutes.Module,
        loadChildren: () =>
          import('./modules/user-permission/user-permission.module').then(
            (m) => m.UserPermissionModule
          ),
      }
    ],
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }


